<template>
  <div>
    <v-btn @click="handleShowForm" color="primary lighten-2">
      Correct
    </v-btn>

    <v-dialog max-width="600" persistent v-if="showModal" v-model="showModal">
      <v-card v-if="!caseInfo && showModal">
        Loading...
      </v-card>
      <v-card v-else>
        <v-card-title class="headline">Estimated completion datetime correction confirmation</v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="isValid">
            <span>Estimated completion datetime: {{caseInfo.response.estimatedCompletionDatetime | DateWithMinutes | NoEmpty}}</span>
            <v-text-field :rules="ecdcReasonRules"
                          label="Reason"
                          placeholder="Please, enter estimated completion datetime correction reason"
                          v-model="form.ecdcReason"
            />
            <v-text-field :rules="ecdcHoursRules"
                          label="Hours"
                          placeholder="How many hours you want to append?"
                          v-model="form.ecdcHours"
            />
            <v-radio-group :rules="ecdcModeRules" row v-model="form.ecdcMode">
              <v-radio label="Add to estimated datetime" value="estimated"/>
              <v-radio label="Add to current time" value="now"/>
            </v-radio-group>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            :disabled="!isSubmitEnabled"
            :loading="requestInProgress"
            @click="handleFormSubmit"
            color="primary darken-1"
            flat="flat">
            Correct
          </v-btn>

          <v-btn
            @click="handleHideForm"
            color="gray darken-1"
            flat="flat">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import {isNumeric} from "../../helpers/types";
  import api from "../../api";
  import {showApiError} from "../../helpers/notification";
  import NoEmpty from "../Filters/NoEmpty";
  import DateWithMinutes from "../Filters/DateWithMinutes";

  function getDefaultFormData() {
    return {
      ecdcReason: null,
      ecdcHours: null,
      ecdcMode: null
    }
  }

  export default {
    name: 'case-estimation-correction-form',
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    components: {},
    props: {
      caseId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        isValid: false,
        showModal: false,
        form: getDefaultFormData(),
        serviceRules: [
          v => !!v || 'Can\'t be null'
        ],
        showSelectService: true, // hacky way to fix vuetify open autoSelect
        requestInProgress: false,
        ecdcModeRules: [
          v => !!v || 'Please select mode'
        ],
        ecdcReasonRules: [
          v => !!v || 'Enter hold reason',
          v => (v && v.length <= 1000) || 'The length of the reason should be no more than 1000 characters'
        ],
        ecdcHoursRules: [
          (value) => {
            if (!isNumeric(value)) {
              return 'Hours must be numeric'
            }

            return true
          }
        ],
      }
    },
    computed: {
      caseInfo() {
        return this.$store.getters.getCaseInfoById(this.caseId);
      },
      isSubmitEnabled() {
        const valid = this.isValid;
        if (!valid) {
          return false
        }

        return true
      },
    },
    mounted() {
      this.fetchCaseByIdIfRequired(this.caseId);
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    methods: {
      ...mapActions({
        fetchCaseByIdIfRequired: 'fetchCaseByIdIfRequired',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.resetForm();
        this.showModal = false
      },
      async handleFormSubmit() {
        if (!this.$refs.form.validate()) {
          return
        }

        this.requestInProgress = true;

        try {
          let updatedCase = await api.correctCaseEstimatedCompletionDatetime(this.caseId,
            parseInt(this.form.ecdcHours),
            this.form.ecdcReason,
            this.form.ecdcMode);

          this.$emit('caseFieldUpdated', {
            caseId: updatedCase.id,
            fieldName: 'ecdcHistory',
            fieldValue: updatedCase.ecdcHistory
          });

          this.$emit('caseFieldUpdated', {
            caseId: updatedCase.id,
            fieldName: 'estimatedCompletionDatetime',
            fieldValue: updatedCase.estimatedCompletionDatetime
          })

        } catch (e) {
          showApiError(this, e, 'Unable to correct case completion datetime');
          throw e
        }

        this.requestInProgress = false;
        this.resetForm();
        this.handleHideForm();
      },
      resetForm() {
        this.form = getDefaultFormData();
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sales/CaseEstimationCorrectionForm.vue